export const ru = {
    campaignCreated: 'Кампания успешно создана',
    hasModeration: 'отправьте кампанию на модерацию',
    hasMoney: 'убедитесь, что на общем счете есть деньги',
    later: 'Позже',
    sendToModeration: 'Отправить на модерацию',
    showConditions: 'Чтобы в этой кампании начались показы объявлений:'
};
